import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { ElementDto } from "./element.dto";
import { CreateElementDto } from "./create-element.dto";
import { UpdateElementDto } from "./update-element.dto";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class ElementsResource extends ResourceBaseService<ElementDto, CreateElementDto, UpdateElementDto> {
  protected EntityDto = ElementDto;
  protected CreateEntityDto = CreateElementDto;
  protected UpdateEntityDto = UpdateElementDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/elements");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }
}
